import {CommonBadlPdfDataProcessor} from '../export-care-plan-common-badl-pdf-data';

export class BathPdfDataProcessor extends CommonBadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
